// Shared sessionStorage key: set right before redirecting to the SSO
// authorize endpoint at the end of the setup wizard. Callback.jsx checks it
// to know an /callback error must NOT be routed back into the setup wizard.
export const POST_SETUP_FLAG = "kt_post_setup_pending";
